import { namespace } from 'vuex-class';
import { ICreateFieldState } from './create-field.types';

export const CreateField = namespace('dealroom/fields/createField');

export enum ECreateFieldAction {
  DropCreate = 'dropCreate',
  ClickCreate = 'clickCreate',
  Create = 'create',
  CreateFailed = 'createFailed',
  CreateSuccess = 'createSuccess',
  Reset = 'reset',
}

export enum ECreateFieldMutation {
  SetOptimisticallyCreatedField = 'setOptimisticallyCreatedField',
  SetUnsuccessfullyCreatedFieldId = 'setUnsuccessfullyCreatedFieldId',
  SetCreatedFieldData = 'setCreatedFieldData',
  SetState = 'setState',
}

export const state: ICreateFieldState = {
  optimisticallyCreatedField: null,
  unsuccessfullyCreatedFieldId: null,
  createdFieldData: null,
};
